/**
 * Select2
 * Means of using our application to remotely search for data
 *
 * @package Monapix
 * @version 3.0.1
 * @author Binary Cats Inc.
 */

require('select2')



// WEBPACK FOOTER //
// ./resources/js/services/select2.js